export const SET_MODE = 'SET_MODE';
